// Central content for the Aruha Trails site.

export const IMAGES = {
  // Aruha's own photography (Kedarkantha / Govind Sanctuary). Swap these files in
  // /app/frontend/public/images to update the site — filenames stay the same.
  logo: "/images/aruha-logo.webp",
  hero: "/images/clouds-valley.webp",
  trekking: "/images/trekkers-rest.webp",
  cafe: "/images/summit-hiker.webp",
  backcountry: "/images/forest-peak.webp",
  summit: "/images/summit-hiker.webp",
  clouds: "/images/clouds-valley.webp",
  // Stock placeholders — replace with your own when ready.
  yoga: "https://images.unsplash.com/photo-1558106340-87553f4cff67?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  climbing: "https://images.unsplash.com/photo-1502126324834-38f8e02d7160?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  culture: "https://images.unsplash.com/photo-1610862784762-330117108fec?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  music: "https://images.unsplash.com/photo-1506157786151-b8491531f063?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHwyfHxvdXRkb29yJTIwbXVzaWMlMjBmZXN0aXZhbHxlbnwwfHx8fDE3ODI4MjIyMTV8MA&ixlib=rb-4.1.0&q=85",
  gallery1: "/images/summit-hiker.webp",
  gallery2: "/images/forest-peak.webp",
  gallery3: "/images/clouds-valley.webp",
};

export const ADVENTURES = [
  {
    id: "kedarkantha-trek",
    name: "Kedarkantha Winter Trek",
    category: "Trekking Tours",
    image: IMAGES.trekking,
    blurb: "Guided ascents to Kedarkantha and beyond — snow-laced ridgelines, alpine meadows, and summit sunrises.",
    span: "lg:col-span-8 lg:row-span-2",
  },
  {
    id: "backcountry",
    name: "High-Altitude Backcountry",
    category: "Expeditions",
    image: IMAGES.backcountry,
    blurb: "Multi-day off-grid expeditions deep into Govind Sanctuary.",
    span: "lg:col-span-4",
  },
  {
    id: "climbing",
    name: "Climbing & Mountaineering",
    category: "Adventure",
    image: IMAGES.climbing,
    blurb: "Rock and ice sessions with certified mountain guides.",
    span: "lg:col-span-4",
  },
  {
    id: "cultural-village",
    name: "Cultural & Village Tours",
    category: "Immersion",
    image: IMAGES.culture,
    blurb: "Walk ancient Garhwali villages, share local kitchens, and meet the mountain communities.",
    span: "lg:col-span-6",
  },
  {
    id: "yoga-retreat",
    name: "Alpine Yoga Retreats",
    category: "Wellness",
    image: IMAGES.yoga,
    blurb: "Breathe at altitude — sunrise flows with the Tons river as your soundtrack.",
    span: "lg:col-span-6",
  },
  {
    id: "music-events",
    name: "Mountain Music Events",
    category: "Gatherings",
    image: IMAGES.music,
    blurb: "Intimate acoustic evenings under a canopy of Himalayan stars.",
    span: "lg:col-span-12",
  },
];

export const ADVENTURE_OPTIONS = ADVENTURES.map((a) => a.name);

// Full list of bookable experiences (matches the Experiences menu). Used by the booking form.
export const EXPERIENCE_OPTIONS = [
  "Kedarkantha Winter Trek",
  "Har Ki Dun Trek",
  "High-Altitude Backcountry",
  "Borasu Pass Expedition",
  "Climbing & Mountaineering",
  "Cultural & Village Tours",
  "Alpine Yoga Retreats",
  "Mountain Music Events",
];

export const CHAPTERS = [
  {
    no: "01",
    title: "A pause in the wilderness",
    body: "Aruha sits within the breathtaking Govind Wildlife Sanctuary — 958 sq. km of untouched Garhwal Himalaya bordering Tibet. Not just a stay, but a basecamp for the wild.",
  },
  {
    no: "02",
    title: "Journeys, not itineraries",
    body: "From Kedarkantha summits to backcountry expeditions, climbing, village immersions and yoga — every experience is guided by people who call these mountains home.",
  },
  {
    no: "03",
    title: "A warm table in the wild",
    body: "After the trail, the Aruha cafe waits — farm-to-table Garhwali cuisine sourced from nearby villages, cooked simply, served with true mountain hospitality.",
  },
];

export const MENU = [
  { tag: "Morning", name: "Mandua Pancakes", desc: "Finger millet pancakes, wild honey, mountain fruit.", price: "₹280" },
  { tag: "Mains", name: "Garhwali Thali", desc: "Chainsoo dal, kafuli greens, aloo ke gutke, rice & roti.", price: "₹450" },
  { tag: "Drinks", name: "French Press Coffee", desc: "Single-origin Uttarakhand coffee, spice shortbread.", price: "₹180" },
  { tag: "Starters", name: "Wild Mushroom Broth", desc: "Forest-foraged mushrooms, Himalayan herbs, village cream.", price: "₹220" },
  { tag: "Bakes", name: "Walnut Loaf", desc: "Stone-ground wheat, Garhwali walnuts, apricot jam.", price: "₹160" },
  { tag: "Desserts", name: "Singori", desc: "Khoya in a maalu leaf cone, chilled saffron cream.", price: "₹200" },
];

export const MARQUEE_ITEMS = [
  "Govind Wildlife Sanctuary",
  "Kedarkantha Basecamp",
  "Farm-to-Table",
  "Snow Leopard Habitat",
  "Alpine Yoga",
  "Backcountry Expeditions",
  "Mountain Music",
  "Garhwal Himalayas",
];

export const MEAL_TIMES = {
  Lunch: ["12:00 PM", "12:30 PM", "1:00 PM", "1:30 PM", "2:00 PM"],
  Dinner: ["6:30 PM", "7:00 PM", "7:30 PM", "8:00 PM", "8:30 PM"],
};

export const WHATSAPP = "917668683973";

export const HERO_SLIDES = [
  {
    image: IMAGES.hero,
    focal: "68% 32%",
    line1: "Adventure in the",
    line2: "heart of the wild",
    caption: "Govind Wildlife Sanctuary · Garhwal Himalayas",
  },
  {
    image: IMAGES.trekking,
    focal: "center 38%",
    line1: "Where the trail ends,",
    line2: "Aruha begins",
    caption: "An alpine basecamp on the way to Kedarkantha",
  },
  {
    image: IMAGES.cafe,
    focal: "center 42%",
    line1: "A warm table",
    line2: "in the wilderness",
    caption: "Farm-to-table Garhwali cuisine · Cafe & Stay",
  },
  {
    image: IMAGES.backcountry,
    focal: "center 38%",
    line1: "Breathe at",
    line2: "altitude",
    caption: "Yoga retreats, culture & mountain music",
  },
];

// Dedicated photo gallery. Add more originals here — the grid adapts automatically.
export const GALLERY = [
  { src: IMAGES.clouds, caption: "Kedarkantha, first light", focal: "68% 30%", cls: "lg:col-span-6 lg:row-span-2 aspect-[3/4]" },
  { src: IMAGES.summit, caption: "The lodge at Aruha", focal: "center 45%", cls: "lg:col-span-3 aspect-square" },
  { src: IMAGES.trekking, caption: "On the trail", focal: "center 40%", cls: "lg:col-span-3 aspect-square" },
  { src: IMAGES.backcountry, caption: "Into the backcountry", focal: "center 38%", cls: "lg:col-span-6 aspect-[16/10]" },
];

export const PRESS = [];

export const SEASONS = [
  {
    season: "Winter",
    months: "December – February",
    title: "Snow Treks",
    body: "Kedarkantha in fresh snow — crisp days, woodfire nights, and summit sunrises over a white Himalaya.",
    image: IMAGES.trekking,
  },
  {
    season: "Spring",
    months: "March – May",
    title: "Rhododendron Trails",
    body: "Blooming oak and rhododendron forests, gentle village walks, and long golden afternoons.",
    image: IMAGES.culture,
  },
  {
    season: "Monsoon",
    months: "June – August",
    title: "Retreats & Cafe",
    body: "Misty, green and quiet — the season for yoga retreats, slow food, and mountain music evenings.",
    image: IMAGES.yoga,
  },
  {
    season: "Autumn",
    months: "September – November",
    title: "Backcountry & Climbing",
    body: "Clear skies and stable weather — ideal for high-altitude expeditions and climbing.",
    image: IMAGES.backcountry,
  },
];

export const EVENTS = [
  {
    season: "Spring",
    months: "March – May",
    title: "Rhododendron Sessions",
    body: "Acoustic evenings among blooming oak and rhododendron forests — soft guitars, poetry, and mountain tea.",
    image: IMAGES.culture,
  },
  {
    season: "Summer",
    months: "June – August",
    title: "Solstice Sound",
    body: "Long-day open-air gatherings by the Tons river — indie folk, jam circles, and starlit dancing.",
    image: IMAGES.clouds,
  },
  {
    season: "Autumn",
    months: "September – November",
    title: "Harvest Nights",
    body: "Folk and fire under crisp autumn skies — local Garhwali musicians and travelling artists.",
    image: "/images/harkidun-sunset.webp",
  },
  {
    season: "Winter",
    months: "December – February",
    title: "Snowfire Sessions",
    body: "Intimate indoor sets around the woodfire — warm chai, slow songs, and falling snow outside.",
    image: IMAGES.trekking,
  },
];

export const TESTIMONIAL = {
  quote:
    "Welcome to the Himalayas open hearts and sweet chai, nights full of shooting stars, and time moving slower. My legs got heavier but my heart got lighter. Trust the universe and it will take you to the most amazing places trust Shivang Dhyani, and he will take you to the beautiful Himalayas.",
  author: "Alicia · Germany · Har Ki Dun Trek",
};

export const CONTACT = {
  list: [
    { name: "Shivang Dhyani", phone: "+91 76686 83973", link: "https://wa.me" },
    { name: "Vikas Negi", phone: "+91 76786 86805", link: "https://wa.me" }
  ],
  location: "Inside Govind Wildlife Sanctuary,\nGarhwal Himalayas, Uttarkashi,\nUttarakhand - on the way to Kedarkantha.",
  hours: "Cafe open daily 8am - 9pm.\nWalk-ins welcome, reservations\npreferred for dinner."
};
// The full editable content model used by the CMS. Stored values (from the
// admin Content Manager) are merged over these defaults at runtime.
export const DEFAULT_CONTENT = {
  hero_slides: HERO_SLIDES,
  adventures: ADVENTURES,
  chapters: CHAPTERS,
  menu: MENU,
  seasons: SEASONS,
  events: EVENTS,
  gallery: GALLERY,
  press: PRESS,
  testimonial: TESTIMONIAL,
  contact: CONTACT,
};
